<template>
  <b-form-group
    :label="$t('fields.team')"
    label-for="id_teams"
  >
    <v-select
      v-model="dataItem.id_teams"
      :options="teamsList"
      label="title"
      :reduce="item => item.id"
      :placeholder="$t('fields.selectTeam')"
      clearable
    />
  </b-form-group>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'ProjectsTeamsCard',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    teamsList() {
      return this.$store.getters['teams/dataList']
    },
    dataItem() {
      return this.$store.getters['projects/dataItem']
    },
  },
  watch: {
    'dataItem.id_departments': function () {
      this.getTeams()
    },
  },
  created() {
    this.getTeams()
  },
  methods: {
    getTeams() {
      const where = { 'teams.status': 1 }
      if (this.dataItem.id_departments) {
        where['teams.id_departments'] = this.dataItem.id_departments
      }
      this.$store.dispatch('teams/getDataList', {
        select: [
          'teams.id AS id',
          'teams.title AS title',
        ],
        where,
        limit: 1000,
        start: 0,
      })
    },
  },
}
</script>
